import React from 'react'
import useLocalStorageState from 'use-local-storage-state';
import { faEnvelope, faPhoneVolume } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import nodata from "../../../../../Utils/assets/img/leads_no_data_found_removebg.png"
import { toast } from 'sonner';
import { navigateToCrmDetail } from '../../../../../Utils/helpers/commonhelper';
import { useLocation, useNavigate } from 'react-router-dom';

export const CompanyContactAccordion = ({ companyData }) => {
    const [PERMISSION] = useLocalStorageState('permission')
    const contactGrants = PERMISSION?.contact
    const navigate = useNavigate()
    const location = useLocation()

    const getRandomColor = () => {
        const colors = [
            { bg: "#E8F4FD", text: "#0B5ED7" },
            { bg: "#E8EAF6", text: "#3F51B5" },
            { bg: "#F3E5F5", text: "#9C27B0" },
            { bg: "#E0F2F1", text: "#009688" },
            { bg: "#E8EAF6", text: "#5C6BC0" },
            { bg: "#FBE9E7", text: "#D84315" }
        ];

        const randomIndex = Math.floor(Math.random() * colors.length);
        return colors[randomIndex];
    };
    return (
        <>
            {
                companyData[0].contact_list.length > 0 ? (
                    companyData[0].contact_list.map((item) => {
                        const contact_phone = JSON.parse(item.user_phone);
                        return (
                            <div
                                style={{
                                    ...styles.contactDetails,
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    if (!contactGrants?.isView) {
                                        toast.warning('You are not authorized for this action!')
                                        return
                                    }
                                    navigateToCrmDetail(
                                        navigate,
                                        location,
                                        `/contactDetails?currContactId=${item.id}`,
                                        {
                                            contactIds: (companyData[0]?.contact_list || []).map(({ id }) => id),
                                        },
                                    )
                                }}
                                key={item.id}
                            >
                                <div
                                    className="rounded-circle overflow-hidden border border-0 d-flex justify-content-center align-items-center"
                                    style={{
                                        ...styles.roundedIcons,
                                        backgroundColor: getRandomColor(item?.id).bg,
                                        color: getRandomColor(item?.id).text
                                    }}
                                >
                                    {
                                        (item.first_name + item.last_name)
                                            .substring(0, 2)
                                            .toUpperCase()
                                    }
                                </div>
                                <div>
                                    <p className="mb-0 d-flex align-items-baseline" style={{ textTransform: 'capitalize', }}>
                                        {item.first_name + " " + item.last_name}
                                        <h6 style={styles.departmentName}>
                                            - {item.designation}
                                        </h6>
                                    </p>
                                    <p
                                        className="mb-0 fs-11"
                                        style={styles.departmentEmails}
                                    >
                                        <span>
                                            <FontAwesomeIcon
                                                icon={faEnvelope}
                                                className="fs-10 me-1"
                                            />{" "}
                                            {item?.email || "-"}
                                        </span>
                                        <span className="ms-2">
                                            <FontAwesomeIcon
                                                icon={faPhoneVolume}
                                                className="fs-10 me-1"
                                            />
                                            {"+" +
                                                contact_phone?.[0]?.country_code +
                                                " " +
                                                contact_phone?.[0]?.phone || "-"}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ position: "absolute", left: "26%", top: "25%" }}
                    >
                        <img
                            src={nodata}
                            alt=""
                            style={{ width: "15rem", marginTop: "0" }}
                        />
                    </div>
                )
            }
        </>

    )
}
const styles = {
    contactDetails: {
        display: "flex",
        alignItems: "center",
        gap: "13px",
        padding: "14px 16px ",
        borderBottom: "0.01rem solid #ebebeb",
    },
    roundedIcons: {
        width: "45px",
        height: "45px",
        backgroundColor: "#d5d6e8",
        color: "#2e384d",
    },
    departmentName: {
        color: "#3f97fd",
        fontSize: "13px",
        fontWeight: 400,
        marginLeft: "9px",
        marginBottom: 0,
    },
    departmentEmails: {
        color: "grey",
        fontWeight: 300,
    },
};
